// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./slide-image-1.jpg");
var dir = previousRequest.replace("slide-image-1.jpg", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "slide-image-1.jpg",
	name: "slide-image-1",
	ext: ".jpg",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/slide-image-1.jpg
// module id = 39
// module chunks = 4